module.exports = __webpack_public_path__ + "static/img/r-3-4-icon.2874702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-3/r-3-4-icon.png
// module id = GcDW
// module chunks = 0